import { useBlockProps } from "@wordpress/block-editor";

export default function save({ attributes }) {
	const {
		images,
		carouselHeight,
		slidesPerView,
		speed,
		autoplay,
		showPagination,
		arrowStyle,
	} = attributes;

	return (
		<div
			{...useBlockProps.save({
				className: `image-carousel swiper-container arrow-${arrowStyle}`,
				style: { height: `${carouselHeight}px` },
				"data-slides": slidesPerView,
				"data-speed": speed,
				"data-autoplay": autoplay ? "true" : "false",
				"data-pagination": showPagination ? "true" : "false",
			})}
		>
			<div className="swiper-wrapper">
				{images.map((img, index) => (
					<div className="swiper-slide" key={index}>
						<img src={img.url} alt={img.alt} loading="lazy" />
					</div>
				))}
			</div>

			<div className="swiper-button-prev"></div>
			<div className="swiper-button-next"></div>
			{showPagination && <div className="swiper-pagination"></div>}
		</div>
	);
}
